import { Component } from '@angular/core';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ClientService } from '../../client.service';
import {
  CLIENT_TTL_ES,
  IClient,
  IClientTable
} from '../../interfaces/client.interface';
import {
  IDENTIFIER_ID,
  TYPE_ID,
  GROUPLOYALTY_ID
} from '../../interfaces/tercero.interface';
import { getTagColor } from '../../../../../../helpers/tag-color.helpers';
@Component({
  selector: 'pg-client',
  templateUrl: './client.component.html'
})
export class ClientComponent extends CrudTemplate implements ICrudTemplate {
  constructor(private serviceBase: ClientService) {
    super(CLIENT_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: CLIENT_TTL_ES,
      columns: [
        { header: 'Nombre', field: 'name' },
        { header: 'Tipo de documento', field: 'identifier' },
        { header: 'N° de documento', field: 'idNumber' },
        { header: 'Tipo de persona', field: 'type' },
        { header: 'Fidelidad', field: 'groupLoyalty', tag: 'tagStatus' },
        { header: 'Dirección', field: 'address' },
        { header: 'Teléfono', field: 'phone' },
        { header: 'Email', field: 'email' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IClient[]) => {
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(
            GROUPLOYALTY_ID[item.groupLoyaltyId]
          );
          return item;
        });
        this.parseToTable(data);
      });
  }

  parseToTable(dataService) {
    const dataTable: IClientTable[] = dataService.map((item) => {
      return {
        ...item,
        identifier: IDENTIFIER_ID[item.identifierId],
        type: TYPE_ID[item.typeId],
        groupLoyalty: GROUPLOYALTY_ID[item.groupLoyaltyId]
      };
    });
    this.table.data = dataTable;
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
